"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6747],{

/***/ 26747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);



const PressList = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(7620), __webpack_require__.e(4128)]).then(__webpack_require__.bind(__webpack_require__, 49533)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(49533)]
  }
});

const PressContainer = _ref => {
  let {
    title,
    data
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(PressList, {
    title: title,
    articles: data
  });
};

/* harmony default export */ __webpack_exports__["default"] = (PressContainer);

/***/ })

}]);